/* RenewaSkin standalone details drawer.
 * Important: deliberately NOT wrapped in Dawn's <header-drawer> component.
 * Dawn's global MenuDrawer binds click-to-close to descendant buttons, which
 * previously closed the drawer when shoppers clicked Shop or a category.
 * Product offers stay regular product-page links.
 */
(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.rsInitialized === 'true') return;

    var details = root.querySelector('details.rs-drawer-details');
    var trigger = root.querySelector('.rs-drawer-trigger');
    var drawer = root.querySelector('.rs-nav-drawer');
    var scroll = root.querySelector('.rs-nav-scroll');
    var shopButton = root.querySelector('[data-rs-open-shop]');
    var panels = root.querySelectorAll('[data-rs-panel]');
    var categoryButtons = root.querySelectorAll('[data-rs-category]');
    var categoryContent = root.querySelectorAll('[data-rs-content]');
    // Track shopper clicks separately from the active category. That way the
    // first click always opens offers, even when a category was shown before.
    var lastClickedCategory = null;

    if (!details || !trigger || !drawer) return;
    root.dataset.rsInitialized = 'true';

    function switchPanel(name, focusElement) {
      panels.forEach(function (element) {
        var active = element.dataset.rsPanel === name;
        element.hidden = !active;
        element.classList.toggle('is-active', active);
      });
      if (shopButton) shopButton.setAttribute('aria-expanded', String(name === 'shop'));
      if (scroll) scroll.scrollTop = 0;
      if (focusElement && details.open) focusElement.focus({ preventScroll: true });
    }

    function selectCategory(name) {
      categoryButtons.forEach(function (button) {
        var selected = button.dataset.rsCategory === name;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      categoryContent.forEach(function (element) {
        var visible = element.dataset.rsContent === name;
        element.hidden = !visible;
        element.classList.toggle('is-hidden', !visible);
      });
    }

    // Shop starts with the three categories only. The first click reveals
    // offers; clicking that same category again follows its collection link.
    function resetCategories() {
      lastClickedCategory = null;
      categoryButtons.forEach(function (button) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
        button.removeAttribute('title');
      });
      categoryContent.forEach(function (element) {
        element.hidden = true;
        element.classList.add('is-hidden');
      });
    }

    function categoryCollectionLink(name) {
      var panel = Array.prototype.find.call(categoryContent, function (element) {
        return element.dataset.rsContent === name;
      });
      // Liquid already outputs these from Header > Shop category destinations.
      return panel && panel.querySelector('a.rs-nav-view-all[href]');
    }

    function closeDrawer(restoreFocus) {
      details.open = false;
      document.documentElement.classList.remove('rs-nav-is-open');
      trigger.setAttribute('aria-expanded', 'false');
      switchPanel('main');
      resetCategories();
      if (restoreFocus) trigger.focus({ preventScroll: true });
    }

    function syncDrawerState() {
      var open = details.open;
      trigger.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('rs-nav-is-open', open);
      if (open) {
        switchPanel('main');
        resetCategories();
        // Keep keyboard focus in the menu when opening from the hamburger.
        var closeButton = root.querySelector('.rs-nav-close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      } else {
        switchPanel('main');
      }
    }

    details.addEventListener('toggle', syncDrawerState);

    root.addEventListener('click', function (event) {
      var openShop = event.target.closest('[data-rs-open-shop]');
      if (openShop) {
        event.preventDefault();
        event.stopPropagation();
        resetCategories();
        switchPanel('shop', root.querySelector('[data-rs-back]'));
        return;
      }

      var back = event.target.closest('[data-rs-back]');
      if (back) {
        event.preventDefault();
        resetCategories();
        switchPanel('main', shopButton);
        return;
      }

      var category = event.target.closest('[data-rs-category]');
      if (category) {
        event.preventDefault();
        var name = category.dataset.rsCategory;
        if (lastClickedCategory === name) {
          var collectionLink = categoryCollectionLink(name);
          if (collectionLink) {
            // Follow the store's actual configured collection URL. Never guess
            // a collection handle for Skincare or Tools.
            window.location.assign(collectionLink.href);
            return;
          }
        }
        lastClickedCategory = name;
        selectCategory(name);
        categoryButtons.forEach(function (button) {
          if (button === category && categoryCollectionLink(name)) {
            button.setAttribute('title', 'Click again to view ' + button.textContent.trim() + ' collection');
          } else {
            button.removeAttribute('title');
          }
        });
        return;
      }

      if (event.target.closest('[data-rs-close]')) {
        event.preventDefault();
        closeDrawer(true);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (!details.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeDrawer(true);
        return;
      }
      // Focus trap so Tab cannot move into the shaded page behind the drawer.
      if (event.key !== 'Tab') return;
      var focusables = Array.prototype.slice.call(drawer.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return element.getClientRects().length > 0 && !element.closest('[hidden]');
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    switchPanel('main');
    resetCategories();
    if (details.open) syncDrawerState();
  }

  function initializeAll() {
    document.querySelectorAll('.rs-drawer-host').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('.rs-drawer-host')) {
      document.documentElement.classList.remove('rs-nav-is-open');
    }
  });
})();
